var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25H3.75C3.3 2.25 3 2.55 3 3V3.75C3 4.2 3.3 4.5 3.75 4.5H12C12.45 4.5 12.75 4.2 12.75 3.75V3C12.75 2.55 12.45 2.25 12 2.25Z",
    fill: "#F64E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.25 8.25H3.75C3.3 8.25 3 7.95 3 7.5C3 7.05 3.3 6.75 3.75 6.75H14.25C14.7 6.75 15 7.05 15 7.5C15 7.95 14.7 8.25 14.25 8.25ZM15 11.25C15 10.8 14.7 10.5 14.25 10.5H3.75C3.3 10.5 3 10.8 3 11.25C3 11.7 3.3 12 3.75 12H14.25C14.7 12 15 11.7 15 11.25ZM12 15C12 14.55 11.7 14.25 11.25 14.25H3.75C3.3 14.25 3 14.55 3 15C3 15.45 3.3 15.75 3.75 15.75H11.25C11.7 15.75 12 15.45 12 15Z",
    fill: "#F64E60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c918e7227e4dc0d893908a60a8075d22.svg";
export { ForwardRef as ReactComponent };